import saladKaramel from './../../../image/salads/saladKaramel.webp'
import prianiiTunecjpg from './../../../image/salads/prianiiTunecjpg.webp'
import cezar from './../../../image/salads/cezar.webp'
import sarada from './../../../image/salads/sarada.webp'
import chukaKrevetka from './../../../image/salads/chukaKrevetka.webp'
import chuka from './../../../image/salads/chuka.webp'

export const imageSalads = {
    saladKaramel:saladKaramel,
    prianiiTunecjpg:prianiiTunecjpg,
    cezar:cezar,
    sarada:sarada,
    chukaKrevetka:chukaKrevetka,
    chuka:chuka
}